<script setup>
import { Phone, Mail, Facebook, GoalIcon, TwitterIcon, LinkedinIcon } from 'lucide-vue-next';
import { useThemeStore } from '../../stores/themeStore';
import Button from './ui/button.vue';

const themeStore = useThemeStore();
</script>

<template>
  <div class="bg-gray-800 text-white hidden  py-2 px-4 md:px-8 lg:px-16 md:flex flex-col md:flex-row items-center justify-between text-sm">
    <div class="flex flex-col md:flex-row items-center gap-2 md:gap-4">
      
      <div class="flex items-center gap-2">
        <Phone :size="14" />
        <span>{{ themeStore.theme.header.topbar.phone }}</span>
      </div>
      <div class="flex items-center gap-2">
        <Mail :size="14" />
        <span>{{ themeStore.theme.header.topbar.email }}</span>
      </div>
    </div>
    <div class="flex items-center gap-4 mt-2 md:mt-0">
      <div class="flex gap-3">
        <a target="_blank" :href=" themeStore.theme.header.topbar.socialLinks.facebook" class="hover:text-bright-yellow transition-colors"><Facebook :size="16" /></a>
        <a target="_blank" :href=" themeStore.theme.header.topbar.socialLinks.twitter" class="hover:text-bright-yellow transition-colors"><TwitterIcon :size="16" /></a>
        <a target="_blank" :href=" themeStore.theme.header.topbar.socialLinks.linkedin" class="hover:text-bright-yellow transition-colors"><LinkedinIcon :size="16" /></a>
      </div>
      <div class="h-8 bg-white w-[1px]  "></div>
      <a href="#" class="hover:text-bright-yellow transition-colors">Login</a>
     
      <Button label="Apply now" variant="primary"/>
    </div>
  </div>
</template> 